function UploadFileHeader(data) {
    // return authorization header with jwt token
    let client = JSON.parse(sessionStorage.getItem("client"));
    if (client && client.token) {
        return {
            Authorization: "Bearer " + client.token,
            "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
        };
    } else {
        return null;
    }
}

export default UploadFileHeader;
